import Ext from "Ext";
import LockTableMouseEventsHandlerState from "./LockTableMouseEventsHandlerState";

export default class ColumnSelectionState extends LockTableMouseEventsHandlerState {
    constructor(mouseEventsHandler) {
        super(mouseEventsHandler);
    }

    resolveTargetCell(cell) {
        cell = cell.getRow().getTable().getLastSelectableRow().getCell(cell.getColIdx());

        // refine columns if we have a row header cell
        if (cell.getColIdx() == 0)
            cell = cell.getRow().getCell(1);

        return cell;
    }

    mouseOver(evt, cell) {
        this.mouseEventsHandler.getSelectionController().changeSelectionTo(this.resolveTargetCell(cell));
    }

    mouseUp(evt, cell) {
        this.mouseEventsHandler.setRangeSelectedState();
        this.mouseEventsHandler.fireSelectionFinished(evt);
    }

    mouseMove(evt, cell) {
        if (Ext.isIE && window.event && window.event.button == 0) {
            this.mouseEventsHandler.getSelectionController().clearSelection();
            this.mouseEventsHandler.setHoverState();
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/ColumnSelectionState.js